export default __webpack_public_path__ + "static/media/pac-qr.4e44fabb.png";